import { render, staticRenderFns } from "./AssetModal.vue?vue&type=template&id=6dd47d12"
import script from "./AssetModal.vue?vue&type=script&lang=js"
export * from "./AssetModal.vue?vue&type=script&lang=js"
import style0 from "./AssetModal.vue?vue&type=style&index=0&id=6dd47d12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports